import { FunctionComponent } from "react";

import ApplicationsPanel from "./ApplicationsPanel";
import QuickActionsPanel from "./QuickActionsPanel";

const Dashboard: FunctionComponent = () => {
  return (
    <div className="flex gap-10" data-testid="dashboard">
      <div className="flex flex-col">
        <div className="flex flex-row">
          <QuickActionsPanel />
        </div>
        <div className="flex flex-row">
          <ApplicationsPanel />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
